export default __webpack_public_path__ + "static/media/contact-avatar.adc23001.png";